"use client";

import React from "react";
import clsx from "clsx";
import styles from "./CertificationNotification.module.scss";
import { CertificationMessageSize } from "@/utils/certifications-utils";
import { useCertificationMessage } from "@/hooks/useCertificationMessage";
import { ProductData } from "@/lib/5874/types";
import { StoreRegion } from "@/lib/_config/stores";
import { ProductListItemType } from "@/lib/bigcommerce-b2b/types";

interface CertificationNotificationProps {
	region: StoreRegion;
	product: ProductData | ProductListItemType;
	messageSize: CertificationMessageSize;
}

const CertificationNotification: React.FC<CertificationNotificationProps> = ({
	messageSize,
	region,
	product,
}) => {
	// Get certifications from the product
	const certifications = (() => {
		if (!product) return;
		if (!["ca", "us"].includes(region)) return;

		const certificationsRequired = product.customFields
			?.find((field) => field.name === "Akeneo|CourseCertification")
			?.value?.split(",")
			.map((cert) => cert.trim());

		return certificationsRequired?.map((c) => c.trim().replace(/[_]/g, " "));
	})();

	// Use the hook to get the message with store settings
	const message = useCertificationMessage(certifications);

	// Don't render anything if no message or certifications
	if (!message || !certifications || certifications.length === 0) return null;

	return (
		<div
			className={clsx(styles.notificationBase, styles[messageSize])}
			role='alert'
		>
			{message}
		</div>
	);
};

export default CertificationNotification;
